<template>
    <div class="news_list">
        <vheader :type="headerType" :current="currentIndex"></vheader>
        <topbanner :img="bannerImg">
          <h1 class="cl_ff tac">新闻资讯</h1>
        </topbanner>

        <div class="news_tab bg_ff">
          <ul class="clearfix f_22">
              <li class="fl tac" @click="_tabchange('16')">
                  <a class="cl_66" :class="{'active': type == '16'}">国家政策</a>
              </li>
              <li class="fl tac" @click="_tabchange('17')">
                  <a class="cl_66" :class="{'active': type == '17'}">行业资讯</a>
              </li>
          </ul>
        </div>

        <div class="new_list_cnt">
            <ul class="w bg_ff">
                <li v-for="item in newList" :key="item.id">
                    <a :href="item.url" target="_blank" title="直购易新闻资讯">
                        <p class="fl">{{item.name}}</p>
                        <span class="fr">发布时间：{{item.createTime}}</span>
                    </a>
                </li>
            </ul>
            <div class="page_box w">
                <el-pagination
                  class="fr"
                  background
                  :page-size="limit"
                  :current-page="currentPage"
                  @current-change="_pagechange"
                  :total="total">
                </el-pagination>
            </div>
        </div>
        <loading v-show="loadingFlag"></loading>
        <vfooter></vfooter>
    </div>
</template>

<script>
    import Loading from '@/components/loading/Loading'
    import vfooter from '@/components/footer/Footer'
    import topbanner from '@/components/topBanner/Topbanner'
    import { Pagination } from 'element-ui'
    import { getNews, getToken } from '@/request/api'
    import vheader from '@/components/header/Header'
    export default {
        name: 'News',
        metaInfo () {
            return {
                title: '互联网企业加快布局新零售',
                meta: [
                    {
                        name: 'keyWords',
                        content: '新闻资讯、行业资讯、新零售'
                    },
                    {
                        name: 'description',
                        content: '新零售趋势愈演愈烈，新概念的词汇是与日俱增，我们如何去理解新零售'
                }]
            }
        },
        data () {
            return {
                bannerImg: require('@/assets/images/news_top.jpg'),
                newList: [],
                type: this.$route.query.type ? this.$route.query.type : '16',
                start: '0',
                limit: 10,
                total: 0,
                currentPage: 1,
                headerType: '2',
                currentIndex: 1,
                loadingFlag: true

            }
        },
        created() {
            this._getnews()
        },
        mounted() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        methods: {
            _getnews() {
                let that = this
                that.loadingFlag = true
                getToken().then(r => {
                    let params = {
                        type: that.type,
                        start: that.start,
                        limit: that.limit
                    }
                    getNews(params, r.data).then(res => {
                        that.newList = res.data.list[`adv_${that.type}`]
                        that.total = parseInt(res.data.count)
                        that.loadingFlag = false
                    })
                })
            },
            _pagechange(page) {
                this.currentPage = page
                this.start = parseInt(page - 1) * 10
                this._getnews()
            },
            _tabchange(type) {
                this.type = type
                this.start = '0'
                this.$router.replace({name: 'news', query: { type: type }})
                this.currentPage = 0
                this._getnews()
            }
        },
        components: {
            topbanner,
            vheader,
            'el-pagination': Pagination,
            vfooter,
            Loading
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/less" lang="less">
    .news_list{
      background: #f2f2f5;
    }
    .topbaner{
        h1{
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 40%;
            z-index: 9;
            font-size: 50px;
        }
    }
    .news_tab{
        box-shadow: 0 1px 19px #e5e5e8;
        ul{
        }
        li{
            width: 50%;
        }
        a{
            display: block;
            height: 62px;
            line-height: 62px;
            border-top: 4px solid #ffffff;
            border-bottom: 4px solid #ffffff;
            &.active{
                 border-bottom: 4px solid #2d68e7;
                 color:#2d68e7;
            }
        }
    }
    .new_list_cnt{
        padding-top: 40px;
        padding-bottom: 80px;
        ul{
            padding: 26px 34px 52px 34px;
            border:1px solid #dcdcdc;
        }
        li{}
        a{
            display: block;
            height: 60px;
            border-bottom: 1px dashed #dcdcdc;
            line-height: 60px;
            color:#666666;
            p{
                margin-left: 42px;
            }
            span{
                margin-right: 42px;
            }
            &:hover{
                p{
                    color:#809ef0;
                }
            }
        }
    }
    .page_box{
        padding-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/news/News.vue